<template>
  <mia-modal
    id="opos-agency-business-modal"
    classes="v--modal flex flex-col"
    width="40%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        Zahlungsinformationen ergänzen
      </h3>
    </mia-modal-header>

    <div class="p-4">
      <p>Dieses Fahrzeug läuft unter dem Agenturmodell. Bitte ergänzen Sie die nachfolgenden Informationen für die Fahrzeugauslieferung.</p>

      <mia-form-section-grid class="mt-4">
        <mia-feature-select
          v-model="form.paymentMethod"
          label="Zahlungsart beim Hersteller"
          :options="paymentMethods"
          name-by="label"
          track-by="id"
        />
      </mia-form-section-grid>
    </div>

    <mia-modal-footer class="flex items-center justify-end">
      <mia-cancel-button
        label="Abbrechen"
        type="button"
        @click="$emit('cancel')"
      />

      <mia-submit-button
        label="Zahlungsinformationen speichern"
        type="button"
        class="ml-3"
        :disabled="!canSubmit"
        @click="onSubmit"
      />
    </mia-modal-footer>
  </mia-modal>
</template>

<script>
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import FormSectionGrid from '@/components/ui/widgets/FormSectionGrid.vue'
import FeatureSelect from '@/components/cars/edit/FeatureSelect.vue'

export default {
  components: {
    'mia-cancel-button': CancelButton,
    'mia-submit-button': SubmitButton,
    'mia-form-section-grid': FormSectionGrid,
    'mia-feature-select': FeatureSelect
  },

  data: () => ({
    form: {
      paymentMethod: ''
    },
    paymentMethods: [
      {
        id: 'cash',
        label: 'Barzahlung'
      },
      {
        id: 'leasing',
        label: 'Leasing'
      },
      {
        id: 'financing',
        label: 'Finanzierung'
      }
    ]
  }),

  computed: {
    canSubmit() {
      return this.form.paymentMethod !== ''
    }
  },

  methods: {
    reset() {
      this.$set(this.form, 'paymentMethod', '')
    },

    onSubmit() {
      this.$emit('submit', { ...this.form })
      this.reset()
    }
  }
}
</script>
